
import React from "react";
import "./AudioList.css";

const AudioList = ({ files = [] }) => {
  return (
    <div className="audio-list">
      {files.map((file, index) => (
        <div className="audio-card" key={index}>
          <h3>{file.name}</h3>

          <audio controls preload="metadata" src={file.play}>
            Your browser does not support audio.
          </audio>
        </div>
      ))}
    </div>
  );
};

export default AudioList;
